import React from 'react'
import Head from 'next/head'
import { NextPageContext } from 'next'
import ErrorPageComponent from '@bluheadless/ui/src/page-components/error/error'
import InternalServerErrorPageComponent from '@bluheadless/ui/src/page-components/internal-server-error/internal-server-error'
import NoRoutePageComponent from '@bluheadless/ui/src/page-components/no-route/no-route'

const statusCodes: { [code: number]: string } = {
	400: 'Bad request',
	404: 'This page could not be found',
	405: 'Method not allowed',
	500: 'Internal server error',
}

export type ErrorProps = {
	statusCode: number
	title?: string
}

function _getInitialProps({ res, err }: NextPageContext): Promise<ErrorProps> | ErrorProps {
	const statusCode = res && res.statusCode ? res.statusCode : err ? err.statusCode! : 404

	return { statusCode }
}

/**
 * `Error` component used for handling errors.
 */
export default class Error<P = {}> extends React.Component<P & ErrorProps> {
	static displayName = 'ErrorPage'

	static getInitialProps = _getInitialProps
	static origGetInitialProps = _getInitialProps

	render() {
		const { statusCode = null } = this.props
		const title = this.props.title || statusCodes[statusCode] || 'A client-side error occurred.'

		let errorComponent = <ErrorPageComponent statusCode={statusCode} />

		switch (statusCode) {
			case 404:
				errorComponent = <NoRoutePageComponent />

				break
			case 500:
				errorComponent = <InternalServerErrorPageComponent />

				break
			default:
				break
		}

		return (
			<div>
				{/* TODO: remove this once RSC supports next/head */}
				{!process?.env.__NEXT_RSC && (
					<Head>
						<title>{title}</title>
					</Head>
				)}

				{errorComponent}
			</div>
		)
	}
}
